import { __assign } from "tslib";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Handle } from 'rc-slider';
import { withFocusable } from 'wix-ui-core/dist/es/src/hocs/Focusable/FocusableHOC';
import { dataHooks } from './constants';
import { st, classes } from './Slider.st.css';
import Tooltip from '../Tooltip';
var SliderHandle = function (_a) {
    var tooltipValue = _a.tooltipValue, className = _a.className, _b = _a.onFocusCustom, onFocusCustom = _b === void 0 ? function () { } : _b, _c = _a.onBlurCustom, onBlurCustom = _c === void 0 ? function () { } : _c, focusableOnFocus = _a.focusableOnFocus, focusableOnBlur = _a.focusableOnBlur, disabled = _a.disabled, handleProps = _a.handleProps, displayTooltip = _a.displayTooltip, index = _a.index, dataHook = _a.dataHook, direction = _a.direction;
    var _d = useState(false), hovered = _d[0], setHovered = _d[1];
    var tooltipRef = React.useRef(null);
    var handleMouseEnter = function () {
        setHovered(true);
    };
    var handleMouseLeave = function () {
        setHovered(false);
    };
    var handleOnFocus = function (event) {
        focusableOnFocus();
        tooltipRef.current.open();
        onFocusCustom(Number(tooltipValue), event);
    };
    var handleOnBlur = function (event) {
        focusableOnBlur();
        tooltipRef.current.close();
        onBlurCustom(Number(tooltipValue), event);
    };
    var tooltipDataHook = dataHook
        ? "".concat(dataHook, "-").concat(dataHooks.sliderTooltip, "-").concat(index)
        : "".concat(dataHooks.sliderTooltip, "-").concat(index);
    return (React.createElement("div", { className: st(classes.sliderHandleWrapper, {}, className), onBlur: handleOnBlur },
        React.createElement(Handle, __assign({}, handleProps, { vertical: direction === 'vertical', onFocus: handleOnFocus, className: st(classes.sliderHandle, { disabled: disabled }), onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, "data-hook": dataHooks.sliderHandle }),
            React.createElement(Tooltip, { ref: tooltipRef, className: classes.sliderHandleTooltip, disabled: !displayTooltip || disabled || !tooltipValue, content: tooltipValue, moveBy: { y: 3 }, dataHook: tooltipDataHook },
                React.createElement("div", { className: st(classes.sliderThumb, { hovered: hovered }), "data-hook": dataHooks.sliderThumb })))));
};
SliderHandle.propTypes = {
    onFocusCustom: PropTypes.func,
    onBlurCustom: PropTypes.func,
    disabled: PropTypes.bool,
    displayTooltip: PropTypes.bool,
    tooltipValue: PropTypes.string,
    index: PropTypes.number,
    dataHook: PropTypes.string,
    handleProps: PropTypes.shape({
        ref: PropTypes.func.isRequired,
        offset: PropTypes.number.isRequired,
        min: PropTypes.number.isRequired,
        max: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
        reverse: PropTypes.bool,
        ariaLabel: PropTypes.string,
    }),
    direction: PropTypes.oneOf(['horizontal', 'vertical']),
};
SliderHandle.defaultProps = {
    displayTooltip: true,
    reverse: false,
};
export default withFocusable(SliderHandle);
//# sourceMappingURL=SliderHandle.js.map